import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";

const DisclosurePolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="border-b border-border bg-gradient-to-br from-primary/5 to-accent/5">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl">
              Disclosure & Affiliate Policy
            </h1>
            <p className="text-lg text-muted-foreground">
              Last updated: November 11, 2025
            </p>
          </div>
        </div>
      </section>

      {/* Disclosure Content */}
      <section className="container mx-auto px-4 py-16 md:py-24">
        <div className="mx-auto max-w-4xl">
          <Card>
            <CardContent className="prose prose-slate max-w-none pt-6 dark:prose-invert">
              <div className="space-y-8">
                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">1. Introduction</h2>
                  <p className="text-muted-foreground">
                    At RunoBlog, we believe in full transparency with our readers. This Disclosure & Affiliate Policy explains how we earn revenue, how we handle affiliate links, and the standards we follow to maintain honesty and integrity in all our content.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    By using www.runoblog.site, you agree to this policy.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">2. Sponsored Content</h2>
                  <p className="text-muted-foreground">
                    From time to time, we may publish sponsored articles, reviews, or promotions from brands or companies.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    All sponsored content will:
                  </p>
                  <ul className="mt-2 space-y-2 text-muted-foreground">
                    <li>Be clearly marked as "Sponsored," "Paid Promotion," or "Ad".</li>
                    <li>Reflect our honest opinions, findings, and experiences.</li>
                    <li>Comply with FTC (Federal Trade Commission) and Google Ad Disclosure guidelines.</li>
                  </ul>
                  <p className="mt-4 text-muted-foreground">
                    We only work with brands that align with our mission and that we believe offer genuine value to our readers.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">3. Affiliate Links</h2>
                  <p className="text-muted-foreground">
                    Some posts on RunoBlog may contain affiliate links. This means if you click on a link and make a purchase, we may earn a small commission — at no extra cost to you.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    Affiliate programs help support the maintenance of our website, allowing us to create more free content and resources.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    We only recommend products or services that:
                  </p>
                  <ul className="mt-2 space-y-2 text-muted-foreground">
                    <li>We have personally used, tested, or researched, and</li>
                    <li>We genuinely believe will benefit our audience.</li>
                  </ul>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">4. Advertising</h2>
                  <p className="text-muted-foreground">
                    We partner with Google AdSense, Adsterra, and other ad networks to display ads on our site, including popunder ads.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    These ads may use cookies or similar tracking technologies to deliver personalized advertising. For more information, please see our:
                  </p>
                  <ul className="mt-2 space-y-1 text-muted-foreground">
                    <li><a href="/privacy" className="text-primary hover:underline">Privacy Policy</a></li>
                    <li><a href="/cookie-policy" className="text-primary hover:underline">Cookie Policy</a></li>
                  </ul>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">5. Product Reviews and Recommendations</h2>
                  <p className="text-muted-foreground">
                    All reviews on RunoBlog are based on our personal opinions and experiences. We strive to provide accurate, unbiased information — regardless of whether we receive compensation.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    If a product or service has been provided to us for free or at a discounted rate in exchange for a review, we will clearly disclose that within the post.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">6. Third-Party Relationships</h2>
                  <p className="text-muted-foreground">
                    We are not responsible for any transactions, guarantees, or representations made by third-party websites or companies mentioned on our site.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    Always review the terms and policies of any external website before making a purchase or sharing personal information.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">7. No Professional Advice</h2>
                  <p className="text-muted-foreground">
                    Content on RunoBlog is for informational and educational purposes only. While we aim to provide helpful guides, tutorials, and opinions, our content should not be considered professional, legal, or financial advice.
                  </p>
                  <p className="mt-4 text-muted-foreground">
                    Always consult a qualified professional before making important decisions based on information found on this website.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">8. Changes to This Policy</h2>
                  <p className="text-muted-foreground">
                    We may update this Disclosure & Affiliate Policy from time to time. Any updates will be reflected by an updated "Last Updated" date at the top of this page.
                  </p>
                </div>

                <div>
                  <h2 className="mb-4 text-2xl font-bold text-foreground">9. Contact Us</h2>
                  <p className="text-muted-foreground">
                    If you have any questions about this Disclosure & Affiliate Policy, please contact us at:
                  </p>
                  <ul className="mt-4 space-y-2 text-muted-foreground">
                    <li>📧 Email: runoux.dev@gmail.com</li>
                    <li>🌐 Website: <a href="https://www.runoblog.site" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://www.runoblog.site</a></li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DisclosurePolicy;
